import * as _ from 'lodash';
import type { VoidFunctionComponent } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { isFreeTier } from '../../../../../../shared/subscriptions';
import { useAddToast } from '../../../../../contexts/ToastContext';
import { window } from '../../../../../globals';
import * as ReportGenerationStore from '../../../../../redux/reportGeneration';
import PaidFeatureGate from '../../../../generic/Gates/PaidFeatureGate';
import { SidebarLayout } from '../../../../layouts';
import type { ProjectGroupContext, ReportGenerationParams } from '../../shared/types';
import Sidebar from '../Sidebar';
import Panel from '../shared/components/Settings';
import { updateReportSettings } from '../shared/utils';
import styles from './ReleaseGroupLevelReport.module.less';

type Props = {
  params: ReportGenerationParams;
};

const ReleaseGroupReportSettings: VoidFunctionComponent<Props> = ({ params }) => {
  const isPaidFeatureGateRestricted = isFreeTier({
    plan: window?.user?.organization?.stripe_plan,
    stripePriceLimit: window?.user?.organization?.stripePriceLimit,
  });
  const reportContext = useSelector(ReportGenerationStore.selectors.getReportContext) as ProjectGroupContext;
  const addToast = useAddToast();
  const dispatch = useDispatch();

  return (
    <div className={styles.settings}>
      <SidebarLayout>
        <SidebarLayout.Main>
          <div className={styles.layout}>
            <Sidebar params={params} resetFormat={_.noop} />
            <PaidFeatureGate isRestricted={isPaidFeatureGateRestricted} hidePill>
              <Panel
                onSave={async ({ shouldSetDefault, file, reportLogoAction, customText, shouldPropagate }) => {
                  try {
                    await updateReportSettings({
                      shouldSetDefault,
                      file,
                      reportLogoAction,
                      customText,
                      shouldPropagate,
                      updateReportCustomTextEndpoint: `/api/project_group/${reportContext.groupId}`,
                    });
                  } catch (e) {
                    addToast({ type: 'error', content: 'Failed to save settings' });
                    return;
                  }

                  dispatch(ReportGenerationStore.actions.setCustomHeaderText(customText));
                  addToast({ type: 'success', content: 'Settings saved' });
                }}
              />
            </PaidFeatureGate>
          </div>
        </SidebarLayout.Main>
      </SidebarLayout>
    </div>
  );
};

export default ReleaseGroupReportSettings;
